/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type AdminCell_user$ref: FragmentReference;
declare export opaque type AdminCell_user$fragmentType: AdminCell_user$ref;
export type AdminCell_user = {|
  +id: string,
  +email: ?string,
  +$refType: AdminCell_user$ref,
|};
export type AdminCell_user$data = AdminCell_user;
export type AdminCell_user$key = {
  +$data?: AdminCell_user$data,
  +$fragmentRefs: AdminCell_user$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AdminCell_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    }
  ],
  "type": "User"
};
// prettier-ignore
(node/*: any*/).hash = '1af73a6256d8e99f0ab5f4f2a26f5917';

module.exports = node;
